module.exports = __webpack_public_path__ + "img/lang1.93e6a8b8.png";